import { kMimeBodyCore } from "../../../Admin/kReusableCoreTS/kMimeBodyCore";
import { AppIndexReader } from "./AppIndex";
import { getCoreUtils } from "../../../Admin/kReusableCoreTS/kCoreHandler";
import { AppAccountPost } from "./AppAccountPost";
import { AppMediaRules } from "./AppMediaRules";
import { AppTextDone, AppTextFail } from "./AppSource";

/** REUSE-JUSTIFIED: AppAccountPost owns the existing hosted JSON POST; this reader validates its
 * media-only payload and turns policy-bounded bytes into the same blob URL AppMediaFill already owns. */
export class AppMediaDownload {
    private Url: string; private Body: string; private Done: AppTextDone; private Failed: AppTextFail;
    private Timer: ReturnType<typeof setTimeout> | null = null;
    private Ended: boolean = false;
    public constructor(Url: string, Body: string, Done: AppTextDone, Failed: AppTextFail) {
        this.Url = Url; this.Body = Body; this.Done = Done; this.Failed = Failed;
    }
    public Start = (): void => {
        if (getCoreUtils().KErrorMode === true) { return; }
        try { this.Timer = setTimeout(this.OnDeadline, 180000); new AppAccountPost(this.Url, this.Body, this.OnAnswer).Send(); }
        catch (e) { getCoreUtils().KGlobalErrorHandler(e, "AppMediaDownload.Start"); this.FinishWait(); this.Failed("The media could not be requested."); }
    };
    private OnAnswer = (Status: number, Text: string): void => {
        // ERROR-SUPPRESSED-JUSTIFIED: a refused/missing photo is an expected state; the button says why.
        try {
            if (this.Ended === true) { return; }
            this.FinishWait();
            const Answer = AppIndexReader.ObjectIn(Text);
            const Request = AppIndexReader.ObjectIn(this.Body);
            if (Status !== 200 || Answer === null || Answer.ok !== true) {
                let Why = "The media is unavailable. Try again shortly.";
                if (Answer !== null && typeof Answer.why === "string") { Why = Answer.why; }
                this.Failed(Why); return;
            }
            if (Request === null || Answer.chatId !== Request.chatId || Answer.messageId !== Request.messageId) {
                this.Failed("The media answer did not match this message."); return;
            }
            if (typeof Answer.name !== "string" || AppMediaRules.Allowed("Media/" + Answer.name) === false
                || typeof Answer.data !== "string" || Answer.data.length > 24 * 1024 * 1024
                || /^[A-Za-z0-9+/]*={0,2}$/.test(Answer.data) === false) { this.Failed("The media answer could not be read."); return; }
            const Decoded = kMimeBodyCore.Base64ToBytes(Answer.data, true);
            if (Decoded.Valid !== true) { this.Failed("The media answer could not be read."); return; }
            if (Decoded.Bytes.length === 0 || Decoded.Bytes.length > 16 * 1024 * 1024) { this.Failed("The media exceeds the download size limit."); return; }
            if (Answer.name.substring(0, Answer.name.lastIndexOf(".")) !== Request.messageId) { this.Failed("The media filename did not match this message."); return; }
            const Bytes = new Uint8Array(Decoded.Bytes);
            this.Done(URL.createObjectURL(new Blob([Bytes], { type: AppMediaRules.TypeFor(Answer.name) })));
        } catch (e) { this.Failed("The media answer could not be read."); }
    };
    private OnDeadline = (): void => {
        // ERROR-SUPPRESSED-JUSTIFIED: network waits expire with a visible retry sentence, not an error report.
        if (this.Ended === true) { return; }
        this.FinishWait(); this.Failed("The media download took too long. Please retry.");
    };
    private FinishWait = (): void => {
        // ERROR-SUPPRESSED-JUSTIFIED: timers must be released after faults and navigation too.
        this.Ended = true;
        if (this.Timer !== null) { clearTimeout(this.Timer); this.Timer = null; }
    };
}
